// Brand-wide constants for Eliabe Jeans (locale-independent identifiers only).
// Localized copy lives in /app/frontend/src/i18n/locales/*.json.
import heroFamily from "@/assets/collections/hero-family.jpg";
import heroAdulto from "@/assets/collections/hero-adulto.jpg";
import infantilImg from "@/assets/collections/infantil.jpg";
import maeBebeImg from "@/assets/collections/mae-bebe.jpg";
import plusSizeImg from "@/assets/collections/plus-size.jpg";

export const BRAND = {
  name: "Eliabe Jeans", // brand name is NOT translated
  wordmark: "ELIABE",
  domain: "eliabejeans.com",
  phoneDisplay: "(81) 98127-7370",
  phoneIntl: "5581981277370",
  email: "contato@eliabejeans.com",
  instagram: "eliabejeans",
  instagramUrl: "https://instagram.com/eliabejeans",
};

// Builds a WhatsApp URL. Accepts an already-translated message string.
export const whatsappUrl = (message) => {
  const text = encodeURIComponent(
    message ||
      "Olá! Vim pelo site da Eliabe Jeans e gostaria de mais informações.",
  );
  return `https://wa.me/${BRAND.phoneIntl}?text=${text}`;
};

// Builds a mailto URL. Accepts an already-translated subject string.
export const mailtoUrl = (subject) => {
  const s = encodeURIComponent(subject || "Contato pelo site - Eliabe Jeans");
  return `mailto:${BRAND.email}?subject=${s}`;
};

// Locale-agnostic collection keys + images. Titles/descriptions come from i18n.
export const COLLECTIONS = [
  { key: "infantil", image: infantilImg },
  { key: "adulto", image: heroAdulto },
  { key: "plus", image: plusSizeImg },
];

export const HERO_IMAGE = heroFamily;
export const ABOUT_IMAGE = maeBebeImg;
